import styled from 'styled-components'

import theme from '@/src/config/theme'

export const Wrapper = styled.div``

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 17px;
`

export const Actions = styled.div`
  display: flex;
  padding-top: 17px;
  justify-content: center;
`

export const FieldsColumns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`

export const FieldsRow = styled.div`
  display: flex;
  align-items: center;

  gap: 17px;

  & > * {
    flex: 1;
  }

  @media (max-width: ${theme.mediaSizes.sm - 1}px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const Label = styled.div`
  padding-top: 7px;
`

export const SuccessTitle = styled.div`
  font-size: 1.75rem;
  font-weight: 450;
  text-align: center;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
`

export const SuccessNote = styled.div`
  text-align: center;
`

export const SuccessClose = styled.div`
  display: flex;
  justify-content: center;
`
